






import { Component, Prop, Vue } from "vue-property-decorator";
import axios from "axios";
import Trend from "@/components/Trend.vue";

let fetchUrl = (uid: number, nextid: number = 0): string =>
  `https://api.vc.bilibili.com/dynamic_svr/v1/dynamic_svr/space_history?visitor_uid=0&host_uid=${uid}&offset_dynamic_id=${nextid}&need_top=1`;
const uid: number = 800631;
const pix: string =
  "https://service-rfwarubo-1251411213.hk.apigw.tencentcs.com/send";
type TrendContent = {
  description: string;
  upload_time: number | string;
  pictures: Array<{
    img_src: string;
    img_height: number;
    img_width: number;
    img_size: number;
  }> | null;
};
type TrendContext = {
  item: TrendContent;
  user: { name: string; head_url: string; uid: number };
  origin: string | TrendContent | null;
  origin_extend_json: string | null;
};
type axiosPostResult = {
  data: { data: { cards: Array<TrendContext>; next_offset: number } };
  status: number;
};
@Component({
  components: {
    Trend
  }
})
export default class extends Vue {
  private list: Array<TrendContext> = [];
  private nextID: number = 0;
  protected loadSwitch: boolean = false;
  protected loading: boolean = false;
  async created() {
    document.title = `${this.$t("app.title")} ${this.$t("app.title_suffix")}`;
    await this.loadPage();
    setTimeout(() => this.monitMore(), 300);
  }
  async loadPage() {
    if (this.loading) return;
    this.loading = true;
    try {
      let url: string = fetchUrl(uid, this.nextID);
      let result: axiosPostResult = await axios.post(pix, { url });
      console.log(result);
      if (result.status === 200) {
        this.nextID = result.data.data.next_offset;
        result.data.data.cards = result.data.data.cards.filter(
          item => !item.origin_extend_json
        );
        result.data.data.cards.map(item => this.list.push(item));
      }
    } catch (e) {
      console.log(e);
    }
    this.loading = false;
  }
  monitMore() {
    setInterval(() => {
      let doc: HTMLDocument | boolean | null = document || false;
      if (doc) {
        let rect: {
          top: number;
          width: number;
        } | null = (doc as any)
          .getElementById("bottom-view")
          .getBoundingClientRect();
        if (rect) {
          let onView: boolean =
            rect.top > -rect.width && rect.top < window.innerHeight;
          if (onView && !this.loadSwitch) {
            this.loadSwitch = true;
            this.loadPage();
          }
          this.loadSwitch = onView;
        }
      }
    }, 300);
  }
}
